export const translations = {
  'zh': () => import('./src/locale/zh.po'),
  'zh-TW': () => import('./src/locale/zh-TW.po'),
  'zh-CN': () => import('./src/locale/zh-CN.po'),
  'vi': () => import('./src/locale/vi.po'),
  'tr': () => import('./src/locale/tr.po'),
  'sq': () => import('./src/locale/sq.po'),
  'so': () => import('./src/locale/so.po'),
  'ru': () => import('./src/locale/ru.po'),
  'pt': () => import('./src/locale/pt.po'),
  'pl': () => import('./src/locale/pl.po'),
  'pa': () => import('./src/locale/pa.po'),
  'nl': () => import('./src/locale/nl.po'),
  'lo': () => import('./src/locale/lo.po'),
  'ko': () => import('./src/locale/ko.po'),
  'ja': () => import('./src/locale/ja.po'),
  'it': () => import('./src/locale/it.po'),
  'ht': () => import('./src/locale/ht.po'),
  'hi': () => import('./src/locale/hi.po'),
  'he': () => import('./src/locale/he.po'),
  'fr': () => import('./src/locale/fr.po'),
  'fr-CA': () => import('./src/locale/fr-CA.po'),
  'fil': () => import('./src/locale/fil.po'),
  'fa': () => import('./src/locale/fa.po'),
  'es': () => import('./src/locale/es.po'),
  'en-GB': () => import('./src/locale/en-GB.po'),
  'en-CA': () => import('./src/locale/en-CA.po'),
  'en-AU': () => import('./src/locale/en-AU.po'),
  'el': () => import('./src/locale/el.po'),
  'de': () => import('./src/locale/de.po'),
  'da': () => import('./src/locale/da.po'),
  'cs': () => import('./src/locale/cs.po'),
  'ar': () => import('./src/locale/ar.po'),
  'am': () => import('./src/locale/am.po'),
};